export const addSubtitlesInPlayer = (subtitles: any, player: any) => {
  if (subtitles?.length) {
    subtitles.forEach((subtitle: any, index: number) => {
      player?.addRemoteTextTrack({
        src: subtitle.src,
        kind: 'subtitles',
        srclang: subtitle.subtitleLanguage, // Default language is English
        label: subtitle.label, // Default label is English
        default: index === 0, // Default track is not set as default
      })
    })
  }
}

export const removeCuePointsInPlayer = (player: any) => {
  const skipIntroButton = player?.el()?.querySelector('.vjs-skip-button')
  if (skipIntroButton) {
    player.el().removeChild(skipIntroButton)
  }
}

const showSkipButton = (player: any, skipSection: any) => {
  const skipButton = player?.el()?.querySelector('.vjs-skip-button')
  if (!skipButton) {
    // Create skip intro button
    const skipIntroButton = document.createElement('button')
    skipIntroButton.innerText = skipSection.label
    skipIntroButton.className = 'vjs-skip-button'
    skipIntroButton.addEventListener('click', () => {
      player.currentTime(skipSection.end)
      removeCuePointsInPlayer(player)
    })
    // Add skip intro button above the control bar on the left side
    player.el().insertBefore(skipIntroButton, player.controlBar.el())
  }
}

export const addCuePointsInPlayer = (currentTime: number, player: any, skipSections: any) => {
  const skipIndex = skipSections.findIndex(
    (section: any) => currentTime >= section.start && currentTime < section.end,
  )
  if (skipIndex >= 0) {
    showSkipButton(player, skipSections[skipIndex])
  } else {
    removeCuePointsInPlayer(player)
  }
}

/* eslint-disable */
// Define constant labels for cuepoint types
export const CUEPOINT_LABELS: Record<string, string> = {
  Logo: 'Skip Logo',
  skip_song: 'Skip Song',
  Skip_intro: 'Skip Intro',
  Skip_recap: 'Skip Recap',
  Skip_credit: 'Skip Credit',
  start_credit: 'Skip Credit',
  end_credit: 'Skip End Credit',
}
/* eslint-enable */

interface Cuepoint {
  cuepointType: string
  cuepointStartTime: number
  cuepointEndTime: number
  adFormat: string
  class: string
}
export const formatCuePoints = (cuepoints: any) => {
  const sortedCuepoints: Cuepoint[] = cuepoints.sort(
    (a: any, b: any) => a.cuepointStartTime - b.cuepointStartTime,
  )

  const mergedCuepoints: { start: number; end: number; label: string }[] = []
  let lastEndTime = -1

  sortedCuepoints.forEach((cuepoint) => {
    if (CUEPOINT_LABELS[cuepoint.cuepointType] && cuepoint.cuepointStartTime > lastEndTime) {
      const label: string = CUEPOINT_LABELS[cuepoint.cuepointType]
      mergedCuepoints.push({
        start: cuepoint.cuepointStartTime,
        end: cuepoint.cuepointEndTime,
        label: label,
      })
      lastEndTime = cuepoint.cuepointEndTime
    }
  })
  return mergedCuepoints
}

export const getCuePointDataFromApiRes = (data: any) => {
  if (data?.ContentMetaCategory?.[0]?.attributes?.cuePointList?.length)
    return data.ContentMetaCategory[0].attributes.cuePointList
  return []
}
